export const formatDate = (date) =>
	date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
	});

export const formatTime = (date) =>
	date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "numeric",
		hour12: true,
	});

export const getFormattedDate = (date) => {
	if (date) {
		const dateObject = new Date(date);
		return `${formatDate(dateObject)} / ${formatTime(dateObject)}`;
	}
};

export const formatDateString = (dateString) => {
	const options = {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		hour12: true,
	};

	const date = new Date(dateString);
	return date.toLocaleString("en-US", options);
};

export const TodaysDate = () => {
	const options = {
		weekday: "long",
		month: "long",
		day: "numeric",
		year: "numeric",
	};
	const today = new Date();
	const current = today.toLocaleDateString("en-US", options);
	return current;
};

export const getFormattedDateALT = (dateValue) => {
	if (dateValue) {
		const options = {
			year: "numeric",
			month: "long",
			day: "numeric",
		};

		const date = new Date(dateValue);
		return date.toLocaleString("en-US", options);
	}
};
